import React from "react";
import { StripeElementsOptions } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeForm from "./StripeForm";

const StripePay = ({
  reference_no,
  multiModeReference,
  handleSyncBooking,
  total,
  stripePromise,
  clientSecret,
  stripePaymentIntent,
  firstName,
  lastName,
  email,
  mobile,
  airport,
  discountCode,
  handleValidate,
  responseError,
  supplierCost,
  service,
  api_tag,
  isVehicle,
  product,
  setAgree,
  agree,
  error
}) => {
  const options = {
    clientSecret,
    appearance: {
      theme: "flat",
      variables: {
        colorPrimary: "#00261E",
        colorBackground: "#f1f5f9",
        colorText: "#1e293b",
        colorDanger: "#ef4444",
        fontFamily: "Outfit, Inter, system-ui, sans-serif",
        spacingUnit: "4px",
        borderRadius: "12px",
      },
      rules: {
        ".Label": {
          display: "flex",
          fontSize: "14px",
          fontWeight: "600",
          color: "#334155",
          marginBottom: "6px",
        },
        ".Input": {
          width: "100%",
          height: "48px",
          border: "2px solid transparent",
          borderRadius: "12px",
          backgroundColor: "#f1f5f9",
          padding: "12px 16px",
          fontSize: "16px",
          fontWeight: "500",
          color: "#1e293b",
          transition: "all 0.2s ease-in-out",
        },
        ".Input:focus": {
          border: "2px solid #00261E",
          backgroundColor: "#ffffff",
          boxShadow: "0 0 0 4px rgba(0, 38, 30, 0.05)",
        },
      },
    },
  };


  return (
    <>
      <Elements options={options} stripe={stripePromise}>
        <StripeForm
          total={total}
          handleSyncBooking={handleSyncBooking}
          reference_no={reference_no}
          multiModeReference={multiModeReference}
          firstName={firstName}
          lastName={lastName}
          email={email}
          mobile={mobile}
          airport={airport}
          clientSecret={clientSecret}
          stripePaymentIntent={stripePaymentIntent}
          discountCode={discountCode}
          handleValidate={handleValidate}
          responseError={responseError}
          service={service}
          supplierCost={supplierCost}
          isVehicle={isVehicle}
          product={product}
          setAgree={setAgree}
          agree={agree}
          error={error}
          api_tag={api_tag}
        />
      </Elements>
    </>
  );
};

export default StripePay;
